import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';

/**
 * Overlay top navigation bar: prev/next item arrows, a breadcrumb
 * (Projects › Request List › `A.2 Item Name`), and a close (X). Replaces the old
 * section-nav sidebar — the design moves item-to-item movement up here.
 *
 * Purely presentational: prev/next availability is decided by the container's
 * selector (`prevItem`/`nextItem` non-null) and the actions bubble as outputs.
 */
@Component({
  selector: 'cxp-crl-overlay-nav',
  templateUrl: './crl-overlay-nav.component.html',
  styleUrls: ['./crl-overlay-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class CrlOverlayNavComponent {
  /** Request name — the middle breadcrumb crumb (links back to the list). */
  readonly requestName = input<string | null>(null);
  /** `A.2`-style number for the trailing crumb. */
  readonly displayNumber = input<string | null>(null);
  /** Item title for the trailing crumb. */
  readonly itemTitle = input<string | null>(null);
  /** Arrow enablement — false greys out + disables the corresponding arrow. */
  readonly hasPrev = input<boolean>(false);
  readonly hasNext = input<boolean>(false);

  readonly prev = output<void>();
  readonly next = output<void>();
  readonly closed = output<void>();
}
